import type { TTranslationKeys } from '@config/i18n';
import {
  DEFAULT_ROLES,
  ROLE_LABELS,
} from '@conversed/shared/src/central/constants/permissions';
import type { TRoleId } from '@conversed/shared/src/central/types/role.types';

const DEFAULT_ROLE_ICON = 'person';

const ROLE_ICONS: Record<string, string> = {
  [DEFAULT_ROLES.AI_TRAINER_ROLE]: 'school',
  [DEFAULT_ROLES.CONTRIBUTOR_ROLE]: 'chat',
  [DEFAULT_ROLES.REVIEWER_ROLE]: 'rate_review',
  [DEFAULT_ROLES.DATA_ANALYST_ROLE]: 'insights',
  [DEFAULT_ROLES.LIVE_CHAT_AGENT_ROLE]: 'support_agent',
  [DEFAULT_ROLES.MANAGER_ROLE]: 'bar_chart',
};

type TRoleLabelKey = (typeof ROLE_LABELS)[keyof typeof ROLE_LABELS];

type TClientRoleLabel = [
  Exclude<TRoleId, typeof DEFAULT_ROLES.SUPER_ADMIN_ROLE>,
  TRoleLabelKey,
];

const isClientRoleLabel = (
  roleLabel: [string, TRoleLabelKey],
): roleLabel is TClientRoleLabel =>
  roleLabel[0] !== DEFAULT_ROLES.SUPER_ADMIN_ROLE;

export const getRoleIcon = (roleId: string): string =>
  ROLE_ICONS[roleId] ?? DEFAULT_ROLE_ICON;

export const getRoleDescriptionKey = (roleId: string): string =>
  `users.role-description.${roleId}`;

// * Every client role in the roles collection, with the title the Roles
// * settings page shows. Used when the viewer cannot edit members, because
// * `/roles/assignable` then returns no role to take the titles from.
export const DEFAULT_CLIENT_ROLES: {
  id: TRoleId;
  titleKey: TTranslationKeys;
}[] = Object.entries(ROLE_LABELS)
  .filter(isClientRoleLabel)
  .map(([id, titleKey]) => ({ id, titleKey }));
